import React from 'react';

import { css } from '@emotion/css';
import { ExcludeDurationOption } from '@recurrency/core-api-schema/dist/common/enums';
import { Radio, Space } from 'antd';

import { ExcludeMinMaxTooltip } from 'pages/purchasing/PlanningPage/modals/ExcludeMinMaxTooltip';
import { PositiveNumberInput } from 'pages/purchasing/PlanningPage/modals/PositiveNumberInput';

import { ConditionalWrapper } from 'components/ConditionalWrapper';
import { PropertyListItem } from 'components/PropertyListItem';
import { RadioGroup } from 'components/Radio';

import { MinMaxSubmissionType } from 'utils/track';

export function MinMaxInputRadio({
  isOpOqVariant,
  submissionType,
  onChangeSubmissionType,
  customMin,
  customMax,
  setCustomMin,
  setCustomMax,
  showExcludingTooltip,
  selectedDuration,
}: {
  isOpOqVariant: boolean;
  submissionType: MinMaxSubmissionType;
  onChangeSubmissionType: (submissionType: MinMaxSubmissionType) => void;
  customMin?: number;
  customMax?: number;
  setCustomMin: (customMin: number | undefined) => void;
  setCustomMax: (customMax: number | undefined) => void;
  showExcludingTooltip: boolean;
  selectedDuration: ExcludeDurationOption;
}) {
  return (
    <RadioGroup
      value={submissionType}
      onChange={({ target: { value } }) => {
        if (value !== MinMaxSubmissionType.Custom) {
          setCustomMin(undefined);
          setCustomMax(undefined);
        }
        onChangeSubmissionType(value);
      }}
    >
      <Space direction="vertical">
        <Radio value={MinMaxSubmissionType.Recommended}>Recommended {isOpOqVariant ? 'OP/OQ' : ''}</Radio>
        {isOpOqVariant && <Radio value={MinMaxSubmissionType.RecommendedMinMax}>Recommended Min/Max</Radio>}
        <Radio value={MinMaxSubmissionType.Custom}>
          <div
            className={css`
              display: flex;
              flex-direction: column;
              gap: 8px;
            `}
          >
            <ConditionalWrapper
              condition={showExcludingTooltip}
              wrapper={(children) => <ExcludeMinMaxTooltip option={selectedDuration}>{children}</ExcludeMinMaxTooltip>}
            >
              <>Custom {isOpOqVariant ? 'OP/OQ' : ''}</>
            </ConditionalWrapper>
            {submissionType === MinMaxSubmissionType.Custom && (
              <>
                <PropertyListItem
                  label={isOpOqVariant ? 'Order Point' : 'Min'}
                  value={
                    <PositiveNumberInput
                      onChange={(inputValue) => {
                        onChangeSubmissionType(MinMaxSubmissionType.Custom);
                        setCustomMin(inputValue);
                      }}
                      disabled={submissionType !== MinMaxSubmissionType.Custom}
                      value={customMin}
                    />
                  }
                />
                <PropertyListItem
                  label={isOpOqVariant ? 'Order Quantity' : 'Max'}
                  value={
                    <PositiveNumberInput
                      onChange={(inputValue) => {
                        onChangeSubmissionType(MinMaxSubmissionType.Custom);
                        setCustomMax(inputValue);
                      }}
                      value={customMax}
                      disabled={submissionType !== MinMaxSubmissionType.Custom}
                      min={customMin}
                    />
                  }
                />
              </>
            )}
          </div>
        </Radio>
      </Space>
    </RadioGroup>
  );
}
